import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { Snackbar, Alert } from "@mui/material";
import { useAuth } from "../components/AuthProvider.tsx";
import Business from "../models/Business.tsx";
import MenuComponent from "../components/Menu.tsx";

function Profile() {
  const { authorization, SetAuthorization } = useAuth();

  const NewBusiness = () => {
    const business: Business = {
      Token: "",
      BusinessId: 0,
      OperatingName: "",
      DesignationNumber: "",
      LegalName: "",
      Address: "",
      City: "",
      PostalCode: "",
      OperatingSectorId: null,
      BusinessSizeId: null,
      YearsOfOperationId: null,
      FirstName: "",
      LastName: "",
      Telephone: "",
      Password: "",
      Email: "",
      IsTermsAndConditions: false,
      IsAdministrator: false
    }
    return business;
  }

  const navigate = useNavigate();
  const [business, SetBusiness] = useState(NewBusiness());
  const [confirmation, SetConfirmation] = useState("");
  const [loaded, SetLoaded] = useState(false);
  const [display_success, SetSuccess] = useState(false);
  const [display_error, SetError] = useState(false);
  const [errors, SetErrors] = useState<string[]>([]);

  useEffect(() => {
    if (authorization) {
      fetch("/api/business?token=" + authorization.Token)
        .then(response => response.json())
        .then(data => {
          SetBusiness(data);
          SetLoaded(true);
        })
        .catch(error => console.log(error));
    }
  }, [authorization]);

  const Submit = (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    // Validate business data
    let validation_errors: string[] = [];
    if (!business.OperatingName ||
      !business.LegalName ||
      !business.Address ||
      !business.City ||
      !business.PostalCode ||
      !business.OperatingSectorId ||
      !business.BusinessSizeId ||
      !business.YearsOfOperationId ||
      !business.FirstName ||
      !business.LastName ||
      !business.Email ||
      !business.Telephone) {
      validation_errors.push("One or more fields are missing.");
    }

    // Validate email uniqueness
    const values = {
      Email: business.Email,
      Password: ""
    }
    const validation_options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(values)
    };

    fetch("/api/validation", validation_options)
      .then(response => response.text())
      .then(data => {
        var result = Number(data);
        if (result > 0 && business.BusinessId !== result ) {
          validation_errors.push("Email is already in use.");
        }

        if (business.Password != "" && business.Password != confirmation) {
          validation_errors.push("Password and confirmation do not match.");
        }

        if (!business.IsTermsAndConditions) {
          validation_errors.push("Terms and conditions must be agreed.")
        }

        SetErrors(validation_errors);
        SetError(validation_errors.length > 0);

        if (validation_errors.length === 0) {          
          SaveBusiness();
        }
      })
      .catch(error => console.log(error));
  }

  const SaveBusiness = () => {
    business.Token = authorization.Token;
    const options = {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(business)
    };

    fetch("/api/business", options)
      .then(response => response.json())
      .then(data => {
        // Update business status
        var isComplete = business.OperatingName &&
          business.LegalName &&
          business.Address &&
          business.City &&
          business.PostalCode &&
          business.OperatingSectorId &&
          business.BusinessSizeId &&
          business.YearsOfOperationId &&
          business.FirstName &&
          business.LastName &&
          business.Email &&
          business.Telephone &&
          business.IsTermsAndConditions;
        const current = {
          Token: business.Token,
          Email: business.Email,
          IsAdministrator: authorization.IsAdministrator,
          IsComplete: isComplete
        };
        SetAuthorization(current);
        navigate("/applications");
      })
      .catch(error => console.error(error));
  }

  const OnChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    if (name == "Confirmation") {
      SetConfirmation(value);
    } else {
      SetBusiness((prevState) => ({ ...prevState, [name]: value }));
    }
  }

  const OnChecked = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    SetBusiness((prevState) => ({ ...prevState, [name]: event.target.checked }));
  }

  return (
    <>
      <Snackbar open={display_success} onClose={() => SetSuccess(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="success" variant="filled" sx={{ width: "100%", padding: 2 }}>
          Your profile has been updated.
        </Alert>
      </Snackbar>

      <Snackbar open={display_error} onClose={() => SetError(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="error" variant="filled" sx={{ width: "100%", padding: 2 }}>
          Your profile could not be updated due to the following errors.
          <ol>
            {errors.map((error, index) =>
              <li key={index}>{error}</li>
            )}
          </ol>
        </Alert>
      </Snackbar>

      <MenuComponent page={"Profile"} />

      <section id="main">
        <div className="container">
          <p>Welcome, we invite you to complete the following employer profile. Please note, <strong>all fields are mandatory</strong> in order to submit an application.</p>
          <form onSubmit={Submit}>
            <p>
              <label>Business Operating Name
                <input type="text" name="OperatingName" value={business.OperatingName} onChange={OnChange} required className={loaded && !business.OperatingName ? "red" : ""} maxLength={100} />
              </label>
            </p>
            <p>
              <label>Business Legal Name
                <input type="text" name="LegalName" value={business.LegalName} onChange={OnChange} required className={loaded && !business.LegalName ? "red" : ""} maxLength={100} />
              </label>
            </p>
            <p>
              <label>Street Address
                <input type="text" name="Address" value={business.Address} onChange={OnChange} required className={loaded && !business.Address ? "red" : ""} maxLength={100} />
              </label>
            </p>
            <p className="halfPostal">
              <label>City
                <input type="text" name="City" value={business.City} onChange={OnChange} required className={loaded && !business.City ? "red" : ""} maxLength={50} />
              </label>
              <label>Postal Code
                <input type="text" name="PostalCode" value={business.PostalCode} onChange={OnChange} required className={loaded && !business.PostalCode ? "red" : ""} maxLength={6} />
              </label>
            </p>
            <p className="half">
              <label>Main Operating Sector
                <select name="OperatingSectorId" value={business.OperatingSectorId} onChange={OnChange} required className={loaded && !business.OperatingSectorId ? "red" : ""}>
                  <option value="">Select</option>
                  <option value="1">Education, law and social, community and government services</option>
                  <option value="2">Health</option>
                  <option value="3">Manufacturing and utilities</option>
                  <option value="4">Sales and service</option>
                  <option value="5">Trades and transport</option>
                </select>
              </label>
            </p>
            <p className="half">
              <label>Size of Business
                <select name="BusinessSizeId" value={business.BusinessSizeId} onChange={OnChange} required className={loaded && !business.BusinessSizeId ? "red" : ""}>
                  <option value="">Select</option>
                  <option value="1">Under 10 employees</option>
                  <option value="2">Under 30 employees</option>
                  <option value="3">Under 50 employees</option>
                  <option value="4">50 employees or more</option>
                </select>
              </label>
            </p>
            <p className="half">
              <label>Years In Operation
                <select name="YearsOfOperationId" value={business.YearsOfOperationId} onChange={OnChange} required className={loaded && !business.YearsOfOperationId ? "red" : ""}>
                  <option value="">Select</option>
                  <option value="1">Under 2 years</option>
                  <option value="2">2 to 5 years</option>
                  <option value="3">Over 5 years</option>
                </select>
              </label>
            </p>
            <p className="half">
              <label>First Name
                <input type="text" name="FirstName" value={business.FirstName} onChange={OnChange} required className={loaded && !business.FirstName ? "red" : ""} maxLength={50} />
              </label>
              <label>Last Name
                <input type="text" name="LastName" value={business.LastName} onChange={OnChange} required className={loaded && !business.LastName ? "red" : ""} maxLength={50} />
              </label>
            </p>
            <p>
              <label>Email Address
                <input type="text" name="Email" value={business.Email} onChange={OnChange} required className={loaded && !business.Email ? "red" : ""} maxLength={255} />
              </label>
            </p>
            <p className="half">
              <label>Phone Number
                <input type="text" name="Telephone" value={business.Telephone} onChange={OnChange} required className={loaded && !business.Telephone ? "red" : ""} maxLength={50} />
              </label>
            </p>
            <p className="half">
              <label>Password
                <input type="password" name="Password" onChange={OnChange} maxLength={50} />
              </label>
              <label>Confirm Password
                <input type="password" name="Confirmation" onChange={OnChange} maxLength={50} />
              </label>
            </p>
            <h2>Acknowledgement</h2>
            <p>I understand that the creation of an Employer Profile does not guarantee:</p>
            <ul>
              <li>Continued eligibility in the program</li>
              <li>Recommendation of your employees</li>
              <li>Unfettered access to the program</li>
              <li>Program integrity investigations will not occur</li>
            </ul>
            <p>
              <label className="form-control"><input type="checkbox" id="terms" name="IsTermsAndConditions" checked={business.IsTermsAndConditions} onChange={OnChecked} /> I accept the above terms and conditions.</label>
            </p>
            <p className="formButton"><input type="submit" value="Update Profile" /></p>
          </form>
        </div>
      </section>
    </>
  );
}

export default Profile;